export default __webpack_public_path__ + "static/media/chevronLeft.77f97c6f.svg";